import { render, staticRenderFns } from "./DetailsPayment.vue?vue&type=template&id=34f3f4c1&scoped=true&"
import script from "./DetailsPayment.vue?vue&type=script&lang=ts&"
export * from "./DetailsPayment.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsPayment.vue?vue&type=style&index=0&id=34f3f4c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f3f4c1",
  null
  
)

export default component.exports